import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Layout from "./components/Layout";
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import NotFound from "pages/NotFound";
import Authentication from './pages/authentication';
import EventDetails from './pages/event-details';
import AttendeeManagement from './pages/attendee-management';
import HostDashboard from './pages/host-dashboard';
import EventBookingFlow from './pages/event-booking-flow';
import UserDashboard from './pages/user-dashboard';
import EventManagement from './pages/event-management';
import EventCreation from './pages/event-creation';
import EventDiscovery from './pages/event-discovery';
import StaffManagement from './pages/staff-management';
import MyTickets from './pages/my-tickets';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public Routes - No Layout */}
            <Route path="/authentication" element={<Authentication />} />
            <Route path="/login" element={<Authentication />} />
            <Route path="/signup" element={<Authentication />} />
            
            {/* Public Event Discovery with Layout */}
            <Route 
              path="/" 
              element={
                <Layout>
                  <EventDiscovery />
                </Layout>
              } 
            />
            <Route 
              path="/events" 
              element={
                <Layout>
                  <EventDiscovery />
                </Layout>
              } 
            />
            <Route 
              path="/event-discovery" 
              element={
                <Layout>
                  <EventDiscovery />
                </Layout>
              } 
            />
            <Route 
              path="/events/:eventId" 
              element={
                <Layout>
                  <EventDetails />
                </Layout>
              } 
            />
            <Route 
              path="/event-details" 
              element={
                <Layout>
                  <EventDetails />
                </Layout>
              } 
            />
            <Route 
              path="/event-details/:eventId" 
              element={
                <Layout>
                  <EventDetails />
                </Layout>
              } 
            />
            
            {/* Protected Routes - Attendee Access */}
            <Route 
              path="/user-dashboard" 
              element={
                <ProtectedRoute requiredRole="attendee">
                  <UserDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute allowedRoles={['attendee']}>
                  <UserDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/booking/:eventId" 
              element={
                <ProtectedRoute allowedRoles={['attendee', 'host']}>
                  <EventBookingFlow />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/event-booking" 
              element={
                <ProtectedRoute allowedRoles={['attendee', 'host']}>
                  <EventBookingFlow />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/event-booking-flow" 
              element={
                <ProtectedRoute allowedRoles={['attendee', 'host']}>
                  <EventBookingFlow />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-tickets" 
              element={
                <ProtectedRoute allowedRoles={['attendee']}>
                  <MyTickets />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/tickets" 
              element={
                <ProtectedRoute allowedRoles={['attendee']}>
                  <MyTickets />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected Routes - Host Access - Using Layout Wrapper */}
            <Route 
              path="/host-dashboard" 
              element={
                <ProtectedRoute requiredRole="host">
                  <HostDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/host" 
              element={
                <ProtectedRoute requiredRole="host">
                  <HostDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/event-creation" 
              element={
                <ProtectedRoute requiredRole="host">
                  <EventCreation />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/create-event" 
              element={
                <ProtectedRoute requiredRole="host">
                  <EventCreation />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/event-management" 
              element={
                <ProtectedRoute requiredRole="host">
                  <EventManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/host/events" 
              element={
                <ProtectedRoute requiredRole="host">
                  <EventManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/attendee-management" 
              element={
                <ProtectedRoute requiredRole="host">
                  <AttendeeManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/attendees/:eventId" 
              element={
                <ProtectedRoute requiredRole="host">
                  <AttendeeManagement />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/staff-management" 
              element={
                <ProtectedRoute requiredRole="host">
                  <StaffManagement />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected Routes - Admin Access */}
            <Route 
              path="/admin-dashboard" 
              element={
                <ProtectedRoute requiredRole="admin">
                  <HostDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* 404 Not Found */}
            <Route 
              path="*" 
              element={
                <Layout>
                  <NotFound />
                </Layout>
              } 
            />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;